export default {
      id: "settings-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#settings-usage",
      toString: function () {
        return this.url;
      }
    }